<template>
  <div v-loading="loading" class="moment-form-page">
    <!-- 基础信息 -->
    <el-card shadow="never" class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-document card-header__icon" />
        <span class="card-header__text">基础信息</span>
      </div>
      <el-form
        ref="baseForm"
        :model="formModel"
        label-width="100px"
        label-position="right"
        class="base-form"
      >
        <el-form-item label="标题" required>
          <el-input
            v-model.trim="title"
            placeholder="请输入标题"
            maxlength="100"
            show-word-limit
            clearable
            class="form-input--wide"
          />
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model.trim="content"
            type="textarea"
            :rows="8"
            placeholder="请输入消息文本内容"
            maxlength="2000"
            show-word-limit
            class="form-input--wide"
          />
        </el-form-item>
        <el-form-item label="发送方式" required>
          <el-select v-model="send_type" placeholder="请选择发送方式" class="form-input--medium">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="评论">
          <el-input
            v-model="comment"
            placeholder="请输入评论（选填）"
            maxlength="300"
            show-word-limit
            clearable
            class="form-input--wide"
          />
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 附件管理 -->
    <el-card shadow="never" class="form-card attachment-card">
      <div slot="header" class="card-header card-header--between">
        <div class="card-header__group">
          <i class="el-icon-paperclip card-header__icon" />
          <span class="card-header__text">附件管理</span>
          <el-tag size="mini" type="info" class="card-header__tag">{{ attachments.length }} / 9</el-tag>
        </div>
        <el-button
          v-if="attachments.length <= 8"
          type="primary"
          size="small"
          icon="el-icon-plus"
          plain
          @click="add"
        >添加附件</el-button>
      </div>

      <div v-if="attachments.length !== 0" class="attachment-tip">
        <i class="el-icon-info" />
        <span>最多支持9个图片类型或者1个链接，类型只能二选一。</span>
        <span>图片附件大小不能超过 10MB</span>
      </div>

      <div v-if="attachments.length === 0" class="attachment-empty">
        <i class="el-icon-folder-opened attachment-empty__icon" />
        <p class="attachment-empty__text">暂无附件，可点击上方按钮添加</p>
        <p class="attachment-empty__hint">内容与附件不能同时为空</p>
      </div>

      <div v-else ref="attachmentList" class="attachment-list">
        <div
          v-for="(item, index) in attachments"
          :key="index"
          class="attachment-item"
        >
          <div class="attachment-item__header">
            <span class="attachment-item__index">附件 {{ index + 1 }}</span>
            <el-radio-group
              v-model="item.msgtype"
              size="small"
              @change="dialogtype(item.msgtype, index)"
            >
              <el-radio-button label="image">图片</el-radio-button>
              <el-radio-button label="link">链接</el-radio-button>
            </el-radio-group>
            <div class="attachment-item__actions">
              <el-button
                type="primary"
                size="mini"
                plain
                icon="el-icon-edit-outline"
                @click="dialogtyper(item.msgtype, index)"
              >编辑</el-button>
              <el-button
                type="danger"
                size="mini"
                plain
                icon="el-icon-delete"
                @click="deleter(index)"
              >删除</el-button>
            </div>
          </div>

          <div class="attachment-item__body">
            <!-- 图片预览 -->
            <template v-if="item.msgtype === 'image'">
              <div
                v-if="item.image && item.image.media_id !== '' && item.image.media_id !== null"
                class="image-preview"
                @click="dialogtyper(item.msgtype, index)"
              >
                <img :src="item.image.pic_url" alt="附件图片">
                <div class="image-preview__mask">
                  <i class="el-icon-edit" />
                  <span>点击更换</span>
                </div>
              </div>
              <div
                v-else
                class="image-uploader"
                @click="dialogtyper(item.msgtype, index)"
              >
                <i class="el-icon-plus image-uploader__icon" />
                <span class="image-uploader__text">选择图片</span>
              </div>
            </template>

            <!-- 链接预览 -->
            <template v-if="item.msgtype === 'link'">
              <div
                v-if="item.link && item.link.title !== '' && item.link.title !== null"
                class="link-preview"
                @click="dialogtyper(item.msgtype, index)"
              >
                <div class="link-preview__title">{{ item.link.title }}</div>
                <div class="link-preview__content">
                  <div class="link-preview__desc">{{ item.link.desc }}</div>
                  <img
                    v-if="item.link.picurl"
                    class="link-preview__thumb"
                    :src="item.link.picurl"
                    alt=""
                  >
                </div>
              </div>
              <div
                v-else
                class="link-placeholder"
                @click="dialogtyper(item.msgtype, index)"
              >
                <i class="el-icon-link" />
                <span>点击配置链接内容</span>
              </div>
            </template>

            <div v-if="!item.msgtype" class="type-placeholder">
              <i class="el-icon-warning-outline" />
              <span>请先选择附件类型</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 底部操作 -->
    <el-card shadow="never" class="form-card form-card--actions">
      <div class="form-actions">
        <el-button @click="goBack">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="onclick">
          保存
        </el-button>
      </div>
    </el-card>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="选择图片"
      :visible.sync="dialogVisibletwo"
      append-to-body
      width="720px"
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <!-- 图文弹窗 -->
    <el-dialog
      title="选择链接"
      :visible.sync="dialogVisibletu"
      append-to-body
      :destroy-on-close="true"
      width="720px"
    >
      <edittuwen ref="tuwenview" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
// import chooseimg from '../menumanagement/components/chooseimg.vue'
import chooseimg from '../menumanagement/components/TencentCloudChooseimg.vue'
// import { spMessage, spMessagelistupdata, sprEnterprise, getMultiTitles } from '@/api/officialaccount.js'
// import { sprEnterprise } from '@/api/officialaccount.js'
import { mptypeslist } from '@/api/sourceMaterial.js'
import edittuwen from './components/edittuwen.vue'
// import wecaht from './components/wecaht.vue'
// import wechat from '../enterpriseAstaff/components/wechat.vue'

import { momentsCreate, momentsDetail, momentsUpdate } from '@/api/workWechat.js'
export default {
  components: { chooseimg, edittuwen },
  data() {
    return {
      radio: '',
      content: '', // 内容
      content0: '',
      title: '', // 标题
      rand_title: 1,
      title_options: [],
      attachments: [
        // { // 数据数组
        // msgtype: ''
        // image: {
        //   source_material_id: '',
        //   pic_url: ''
        // }
        //   "link": {
        // 	"title": "消息标题",
        // 	"picurl": "https://example.pic.com/path",
        // 	"desc": "消息描述",
        // 	"url": "https://example.link.com/path"
        // }
      // }
      ],
      dialogVisibletwo: false, // 图片库弹窗
      dialogVisibletu: false, // 图文的弹窗
      dialogVisibleshi: false,
      dialogVisiblewechat: false, // 小程序的弹窗
      activetype: '', // 类型
      activeindex: null, // 选择的索引
      type: null, // 新增还是编辑类型
      sp_message_no: null, // 编辑的id
      programtype: [], // 小程序类型
      attachmentsarrs: [], // 数据数组(要传的)
      ids: null,
      loading: false,
      submitting: false,
      dialogVisiblewecaht: false,
      push_method: 1,
      tihuan: [{ value: '111' }, { value: '222' }],
      show: false,
      newContent: [],
      id: 0,
      comment: '',
      send_type: 2,
      options: [{
        value: 2,
        label: '第三方'
      }, {
        value: 1,
        label: '官方'
      }]
    }
  },
  computed: {
    pageTitle() {
      const t = Number(this.type)
      if (t === 1) return '新增朋友圈消息'
      if (t === 3) return '复用朋友圈消息'
      return '编辑朋友圈消息'
    },
    formModel() {
      return {
        title: this.title,
        content: this.content,
        send_type: this.send_type,
        comment: this.comment
      }
    }
  },
  created() {
    this.getmptypeslist()
    this.type = this.$route.query.type
    console.log(this.$route.query.type)
    if (this.$route.query.type === 1) {
      console.log('新增')
    } else {
      this.ids = this.$route.query.sp_moments_no
      console.log('this.ids', this.ids)
      this.detail()
    }
    this.id = this.$route.query.id
  },
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    dialogtype(type, index) {
      if (type === 'image') {
        if (this.attachments[index].image) {
          console.log('有image')
        } else {
          this.attachments[index].image = {}
          this.attachments[index].image.media_id = ''
          this.attachments[index].image.pic_url = ''
        // delete this.attachments[index].link
        // delete this.attachments[index].miniprogram
        }
      } else if (type === 'link') {
        if (this.attachments[index].link) {
          console.log('有link')
        } else {
          this.attachments[index].link = {}
          this.attachments[index].link.title = ''
          this.attachments[index].link.picurl = ''
          this.attachments[index].link.media_id = ''
          // this.attachments[index].link.desc = ''
          this.attachments[index].link.url = ''
          // this.attachments[index].link.rand_title = 0
          // this.attachments[index].link.title_options = []
          // this.attachments[index].link.rand_desc = 0
          // this.attachments[index].link.desc_options = []
        // delete this.attachments[index].image
        // delete this.attachments[index].miniprogram
        }
      } else {
        this.attachments[index].link.media_id = ''
      }
    },
    dialogtyper(type, index) {
      if (type === '') {
        this.$message.error('请选择要编辑的类型')
        return
      }
      if (type === null) {
        this.$message.error('请选择要编辑的类型')
        return
      }
      console.log('type', type)
      this.activetype = type
      this.activeindex = index
      if (type === 'image') {
        this.dialogVisibletwo = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.mychild.parentHandleclick('1')
        }, 100)
      } else if (type === 'link') {
        this.dialogVisibletu = true
        const link = this.attachments[index].link || {}
        if (!link.title) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send({})
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.tuwenview.send(link)
          }, 100)
        }
      } else {
        this.dialogVisibleshi = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.mychild.parentHandleclick('1')
        }, 100)
      }
    },
    add() {
      this.attachments.push({
        msgtype: ''
      })
      this.newContent = this.tihuan.slice()
      this.newContent.unshift(this.content)

      console.log('this.newContent', this.newContent)
      this.scrollAttachmentListToBottom()
    },
    scrollAttachmentListToBottom() {
      const scroll = () => {
        const el = this.$refs.attachmentList
        if (el) {
          el.scrollTop = el.scrollHeight
        }
      }
      // 首次添加时 v-if 切换，需等 DOM 渲染完成后再滚动
      this.$nextTick(() => {
        this.$nextTick(() => {
          requestAnimationFrame(scroll)
        })
      })
    },
    deleter(index) {
      this.attachments.splice(index, 1)
    },
    async onclick() {
      console.log('this.attachments', this.attachments)
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.attachments.length === 0) {
        if (this.content === '' || this.content === null) {
          this.$message.error('内容和附件不能同时为空')
          return
        }
      }
      // if (this.attachments.length === 0 && this.content === '') {
      //   this.$message.error('内容和附件不能都为空')
      //   return
      // }

      const msgtypebool = this.attachments.every((item, index, array) => {
        return item.msgtype
      })
      if (msgtypebool === false) {
        this.$message.error('请选择类型')
        return
      }

      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'link') {
          if (this.attachments[i].link.title === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息图文附件`)
            return
          }
        }
      }

      for (let i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].msgtype === 'image') {
          if (this.attachments[i].image.pic_url === '') {
            this.$message.error(`请完善要编辑的第${i + 1}条消息图片附件`)
            return
          }
        }
      }
      console.log(' this.attachments', this.attachments)
      this.attachmentsarrs = []
      this.attachments.forEach((item, index) => {
        if (item.msgtype === 'link') {
          this.attachmentsarrs.push({
            msgtype: 'link',
            link: item.link
          })
        }
        if (item.msgtype === 'image') {
          this.attachmentsarrs.push({
            msgtype: 'image',
            image: item.image
          })
        }
      })
      this.submitting = true
      const payload = {
        title: this.title,
        content: this.content,
        comment: this.comment,
        id: this.id,
        attachments: this.attachmentsarrs,
        send_type: this.send_type
      }
      try {
        if (this.type === 1 || this.type === 3) {
          await momentsCreate(payload)
        } else {
          await momentsUpdate(payload)
        }
        this.$router.go(-1)
      } finally {
        this.submitting = false
      }
    },
    clickicon(img, key) {
      if (this.activetype === 'image') {
        this.dialogVisibletwo = false
        this.attachments[this.activeindex].image.media_id = key
        this.attachments[this.activeindex].image.pic_url = img
      }
    },
    callback(form, title_options, desc_options) {
      if (this.activetype === 'link') {
        console.log('111')
        this.dialogVisibletu = false
        this.attachments[this.activeindex].link.title = form.title
        this.attachments[this.activeindex].link.picurl = form.testsrc
        this.attachments[this.activeindex].link.media_id = form.media_id
        // this.attachments[this.activeindex].link.desc = form.description
        this.attachments[this.activeindex].link.url = form.url
        // this.attachments[this.activeindex].link.title_options = title_options
        // this.attachments[this.activeindex].link.desc_options = desc_options
      }
    },
    // callwechat(form) {
    //   if (this.activetype === 'miniprogram') {
    //     this.dialogVisiblewechat = false
    //     console.log('form', form)
    //     this.attachments[this.activeindex].miniprogram.title = form.name
    //     this.attachments[this.activeindex].miniprogram.source_material_id = form.sourceMaterialId
    //     this.attachments[this.activeindex].miniprogram.appid = form.appid
    //     this.attachments[this.activeindex].miniprogram.page = form.link
    //     this.attachments[this.activeindex].miniprogram.pic_media_src = form.programimg
    //   }
    // },
    // wechatcallback(form) {
    //   if (this.activetype === 'sp_miniprogram') {
    //     this.dialogVisiblewecaht = false
    //     console.log('form', form)
    //     this.attachments[this.activeindex].sp_miniprogram.app_id = form.app_id
    //     this.attachments[this.activeindex].sp_miniprogram.des_1 = form.des_1
    //     this.attachments[this.activeindex].sp_miniprogram.pagepath = form.pagepath
    //     this.attachments[this.activeindex].sp_miniprogram.title = form.title
    //     this.attachments[this.activeindex].sp_miniprogram.weappiconurl = form.weappiconurl
    //     this.attachments[this.activeindex].sp_miniprogram.miniprogram_no = form.miniprogram_no
    //     this.attachments[this.activeindex].sp_miniprogram.thumburl = form.thumburl
    //   }
    // },
    opens(type, item) {
      this.getmptypeslist()
      this.type = type
      if (type === 1) {
        console.log('新增')
        // this.attachments = item.attachments
      } else {
        console.log(item)
        this.ids = item.sp_message_no
        this.detail()
      }
    },
    async detail() {
      this.loading = true
      const data = await momentsDetail({
        sp_moments_no: this.ids
      })
      console.log('详情------', data.data)
      this.attachments = []
      this.title = data.data.item.title
      this.content = data.data.item.content === null ? '' : data.data.item.content
      this.comment = data.data.item.comment === null ? '' : data.data.item.comment
      this.send_type = data.data.item.send_type === null ? '' : data.data.item.send_type
      // this.rand_title = data.data.rand_title
      // this.title_options = data.data.title_options
      this.attachments = data.data.item.attachments
      this.sp_message_no = data.data.item.sp_moments_no
      // this.push_method = data.data.push_method
      this.loading = false
      console.log('data', data)
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    },
    sendcahaer(val) {
      if (val === 1) {
        console.log('attachments1', this.attachments)
        this.attachments.forEach((item) => {
          if (item.msgtype !== '') {
            item.msgtype = ''
          }
        })
      } else {
        console.log('attachments2', this.attachments)
        this.attachments.forEach((item) => {
          if (item.msgtype !== '') {
            item.msgtype = ''
          }
        })
      }
    }
    // changewr(item, index) {
    //   console.log(item)
    //   this.$nextTick(() => {
    //     this.$forceUpdate()
    //   })
    //   if (item.link.rand_title === 1) {
    //     getMultiTitles({
    //       text: item.link.title
    //     }).then(res => {
    //       console.log('111', res)
    //       item.link.title_options = res.data
    //       this.$nextTick(() => {
    //         this.$forceUpdate()
    //       })
    //     })
    //   } else {
    //     item.link.title_options = []
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }
    // },
    // changewrr(item) {
    //   this.$nextTick(() => {
    //     this.$forceUpdate()
    //   })
    //   if (item.link.rand_desc === 1) {
    //     getMultiTitles({
    //       text: item.link.desc
    //     }).then(res => {
    //       console.log('222', res)
    //       item.link.desc_options = res.data
    //       this.$nextTick(() => {
    //         this.$forceUpdate()
    //       })
    //     })
    //   } else {
    //     item.link.desc_options = []
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }
    // },
    // changewrrr() {
    //   this.$nextTick(() => {
    //     this.$forceUpdate()
    //   })
    //   if (this.rand_title === 1) {
    //     getMultiTitles({
    //       text: this.content
    //     }).then(res => {
    //       console.log('111', res)
    //       this.title_options = res.data
    //       this.$nextTick(() => {
    //         this.$forceUpdate()
    //       })
    //     }).catch(() => {
    //       this.title_options = []
    //       this.$nextTick(() => {
    //         this.$forceUpdate()
    //       })
    //     })
    //   } else {
    //     this.title_options = []
    //     this.$nextTick(() => {
    //       this.$forceUpdate()
    //     })
    //   }
    // },
    // contneer() {
    //   if (this.rand_title === 1) {
    //     getMultiTitles({
    //       text: this.content
    //     }).then(res => {
    //       console.log('111', res)
    //       this.title_options = res.data
    //       this.$nextTick(() => {
    //         this.$forceUpdate()
    //       })
    //     }).catch(() => {
    //       this.title_options = []
    //     })
    //   }
    // },
    // deater(index) {
    //   this.title_options.splice(index, 1)
    // }
  }
}
</script>

<style scoped>
.moment-form-page {
  min-height: calc(100vh - 84px);
  padding: 20px 24px 24px;
  background: #f0f2f5;
  box-sizing: border-box;
}

/* 页头 */
.page-header {
  margin-bottom: 16px;
}

.page-header__left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.page-header__back {
  margin-top: 4px;
  flex-shrink: 0;
}

.page-header__title {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.page-header__desc {
  margin: 0;
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}

/* 卡片 */
.form-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__header {
  padding: 14px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__body {
  padding: 24px 20px 8px;
}

.card-header {
  display: flex;
  align-items: center;
}

.card-header--between {
  justify-content: space-between;
}

.card-header__group {
  display: flex;
  align-items: center;
}

.card-header__icon {
  margin-right: 8px;
  font-size: 16px;
  color: #3a71a8;
}

.card-header__text {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.card-header__tag {
  margin-left: 10px;
}

/* 表单 */
.base-form {
  max-width: 920px;
}

.form-input--wide {
  width: 100%;
  max-width: 760px;
}

.form-input--medium {
  width: 240px;
}

/* 附件提示 */
.attachment-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  padding: 8px 12px;
  font-size: 13px;
  color: #e6a23c;
  background: #fdf6ec;
  border-radius: 4px;
  border: 1px solid #faecd8;
}

.attachment-tip .el-icon-info {
  font-size: 14px;
}

/* 空状态 */
.attachment-empty {
  padding: 48px 20px;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
}

.attachment-empty__icon {
  font-size: 48px;
  color: #c0c4cc;
}

.attachment-empty__text {
  margin: 12px 0 4px;
  font-size: 14px;
  color: #606266;
}

.attachment-empty__hint {
  margin: 0;
  font-size: 12px;
  color: #909399;
}

/* 附件列表 */
.attachment-list {
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;
}

.attachment-item {
  margin-bottom: 16px;
  padding: 16px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  transition: box-shadow 0.2s;
}

.attachment-item:last-child {
  margin-bottom: 0;
}

.attachment-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.attachment-item__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.attachment-item__index {
  font-size: 14px;
  font-weight: 600;
  color: #3a71a8;
  min-width: 56px;
}

.attachment-item__actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.attachment-item__body {
  padding-left: 4px;
}

/* 图片上传/预览 */
.image-uploader,
.image-preview {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
}

.image-uploader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #c0c4cc;
  background: #fff;
  transition: border-color 0.2s, color 0.2s;
}

.image-uploader:hover {
  border-color: #3a71a8;
  color: #3a71a8;
}

.image-uploader__icon {
  font-size: 28px;
  color: #c0c4cc;
  margin-bottom: 6px;
}

.image-uploader:hover .image-uploader__icon {
  color: #3a71a8;
}

.image-uploader__text {
  font-size: 12px;
  color: #909399;
}

.image-preview {
  position: relative;
  border: 1px solid #ebeef5;
  background: #fff;
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-preview__mask {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s;
}

.image-preview:hover .image-preview__mask {
  opacity: 1;
}

.image-preview__mask .el-icon-edit {
  font-size: 20px;
}

/* 链接预览 */
.link-preview {
  max-width: 280px;
  padding: 12px;
  background: #fff;
  border: 1px solid #67c23a;
  border-radius: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.link-preview:hover {
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.2);
}

.link-preview__title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 10px;
}

.link-preview__content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.link-preview__desc {
  flex: 1;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 54px;
}

.link-preview__thumb {
  width: 50px;
  height: 50px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 4px;
}

.link-placeholder,
.type-placeholder {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  font-size: 13px;
  color: #909399;
  background: #fff;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.link-placeholder:hover {
  border-color: #3a71a8;
  color: #3a71a8;
}

.type-placeholder {
  cursor: default;
  color: #e6a23c;
  border-color: #faecd8;
  background: #fdf6ec;
}

/* 底部操作 */
.form-card--actions ::v-deep .el-card__body {
  padding: 16px 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

@media (max-width: 768px) {
  .moment-form-page {
    padding: 16px;
  }

  .base-form {
    max-width: 100%;
  }

  .form-input--wide,
  .form-input--medium {
    max-width: 100%;
    width: 100% !important;
  }

  .attachment-item__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .attachment-item__actions {
    margin-left: 0;
    width: 100%;
  }
}
</style>
